import type { MagentoGetProductPrice } from "@jti/magento-types";

export const getProductPriceResponseMock: MagentoGetProductPrice = {
  maximumPrice: {
    finalPrice: {
      currency: "EUR",
      value: 400,
    },
    regularPrice: {
      currency: "EUR",
      value: 600,
    },
  },
  minimumPrice: {
    finalPrice: {
      currency: "EUR",
      value: 400,
    },
    regularPrice: {
      currency: "EUR",
      value: 600,
    },
  },
};
